(() => {
  const pendingWidgets = new Set();
  const observedWidgets = new WeakSet();
  let bootstrapLoading = false;

  function hydrateWidget(widget) {
    if (!window.Trustpilot?.loadFromElement) return;
    if (widget.querySelector('iframe')) {
      pendingWidgets.delete(widget);
      return;
    }

    window.Trustpilot.loadFromElement(widget, true);
    pendingWidgets.delete(widget);
  }

  function hydrateVisibleWidgets() {
    pendingWidgets.forEach(hydrateWidget);
  }

  function loadTrustpilotBootstrap() {
    if (window.Trustpilot?.loadFromElement) {
      hydrateVisibleWidgets();
      return;
    }
    if (bootstrapLoading) return;
    bootstrapLoading = true;

    const existingScript = document.querySelector(
      'script[data-trustpilot-bootstrap], script[src*="widget.trustpilot.com/bootstrap"]',
    );
    if (existingScript) {
      existingScript.addEventListener('load', () => requestAnimationFrame(hydrateVisibleWidgets), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    script.dataset.trustpilotBootstrap = 'true';
    script.addEventListener('load', () => requestAnimationFrame(hydrateVisibleWidgets), { once: true });
    document.head.appendChild(script);
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.unobserve(entry.target);
          pendingWidgets.add(entry.target);
          loadTrustpilotBootstrap();
        });
      }, { rootMargin: '0px 0px 100px' })
    : null;

  // Picks up widgets the page has not seen yet. The cart drawer replaces its markup on every
  // cart update, so it calls this after each render to get its new widget hydrated.
  function scan() {
    document.querySelectorAll('.trustpilot-widget').forEach((widget) => {
      if (observedWidgets.has(widget)) return;
      observedWidgets.add(widget);

      if (observer) {
        observer.observe(widget);
        return;
      }
      pendingWidgets.add(widget);
      loadTrustpilotBootstrap();
    });
  }

  window.OGKicksTrustpilot = { scan };
  scan();
})();
